<template>
  <div class="custom-sort"
    v-if="isCustomSorted || computedCanCustomSort"
    :class="{ 'edit-mode': isEditMode }">
    <span v-if="isCustomSorted" class="sorted">
      <i class="icon icon--custom-sort"></i>
      <span class="text">{{ $t('dashboard.customSort.sorted.title') }}</span>
      <ui-icon-tooltip class="tooltip"
        iconSize="normal"
        arrowTop arrowCenter>
        <span v-html="$t('dashboard.customSort.sorted.tooltip')"></span>
      </ui-icon-tooltip>
    </span>
    <span v-else-if="computedCanCustomSort" class="sort">
      <ui-button
        iconName="icon--undo"
        size="small"
        :disabled="isEditMode"
        @click="$emit('onSortOptionChange', columnName, true)">
        <span class="text">{{ $t('dashboard.customSort.sort.title') }}</span>
      </ui-button>
      <ui-icon-tooltip
        v-if="!isEditMode"
        iconSize="normal"
        arrowTop arrowCenter>
        <span v-html="$t('dashboard.customSort.sort.tooltip')"></span>
      </ui-icon-tooltip>
    </span>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'

export default {
  name: 'CustomSortButton',
  components: {
    UiButton,
    UiIconTooltip
  },
  props: [
    'columnName',
    'isEditMode',
    'sortColumn',
    'canCustomSort'
  ],
  data () {
    return {
      initialSortColumn: this.sortColumn,
      initialCanCustomSort: this.canCustomSort
    }
  },
  computed: {
    computedSortColumn () {
      return this.isEditMode ? this.initialSortColumn : this.sortColumn
    },
    computedCanCustomSort () {
      return this.isEditMode ? this.initialCanCustomSort : this.canCustomSort
    },
    isCustomSorted () {
      return this.computedCanCustomSort && this.columnName === this.computedSortColumn
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-sort {
  display: inline-block;
  vertical-align: top;
  position: relative;
  top: 2px;
  box-sizing: border-box;

  .text {
    font-size: 13px;
    color: #444;
  }

  .tooltip {
    position: relative;
  }

  .sorted {
    position: relative;
    margin-left: 15px;
    &::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 11px;
      background-color: #c1c1c1;
      margin-right: 10px;
      position: relative;
    }

    i {
      vertical-align: middle;
      margin-right: 3px;
    }
    .text {
      vertical-align: middle;
    }
    .tooltip {
      margin-left: 6px;
      top: -1px;
    }
  }
  .sort {
    margin-left: 15px;
    position: relative;
    button {
      /*vertical-align: middle;*/
      margin: -10px 0;
    }
    .tooltip {
      margin-left: 8px;
    }
  }

  &.edit-mode {
    vertical-align: top;
    top: 0;

    .sorted {
      top: 11px;
      &::before {
        display: none;
      }
    }

    .sort {
      margin-left: 10px;
      top: 1px;
      button {
        margin: 0;

        &[disabled] {
          opacity: 0.3;
        }
      }
    }
  }
}
</style>
